export const clusterData = [
    {
      "city_id": 1,
      "region_id": 7,
      "name_ar": "تبوك",
      "name_en": "Tabuk",
      "center": [
        28.41463997,
        36.53387003
      ]
    },
    {
      "city_id": 2,
      "region_id": 7,
      "name_ar": "نعمي",
      "name_en": "Na'mi",
      "center": [
        28.30507995,
        35.74931003
      ]
    },
    {
      "city_id": 3,
      "region_id": 1,
      "name_ar": "الرياض",
      "name_en": "Al Ward",
      "center": [
        24.7135517,
        46.7652957
      ]
    },
    {
      "city_id": 4,
      "region_id": 7,
      "name_ar": "حميط",
      "name_en": "Humayt",
      "center": [
        28.65152001,
        35.38013
      ]
    },
    {
      "city_id": 5,
      "region_id": 2,
      "name_ar": "الطائف",
      "name_en": "At Taif",
      "center": [
        21.26848005,
        40.41667003
      ]
    },
    {
      "city_id": 6,
      "region_id": 2,
      "name_ar": "مكة المكرمة",
      "name_en": "Makkah",
      "center": [
        21.42717994,
        39.84349001
      ]
    },
    {
      "city_id": 7,
      "region_id": 7,
      "name_ar": "رجم الطيارة",
      "name_en": "Rajm At Tayarah",
      "center": [
        29.60751999,
        37.23556001
      ]
    },
    {
      "city_id": 8,
      "region_id": 7,
      "name_ar": "الثميد",
      "name_en": "Ath Thumayd",
      "center": [
        29.93183995,
        37.16726002
      ]
    },
    {
      "city_id": 9,
      "region_id": 7,
      "name_ar": "عسيلة",
      "name_en": "'Usaylah",
      "center": [
        29.89939006,
        36.98046006
      ]
    },
    {
      "city_id": 10,
      "region_id": 8,
      "name_ar": "حائل",
      "name_en": "Hail",
      "center": [
        27.53054999,
        41.69733002
      ]
    },
    {
      "city_id": 11,
      "region_id": 4,
      "name_ar": "بريدة",
      "name_en": "Buraidah",
      "center": [
        26.33033999,
        43.97435997
      ]
    },
    {
      "city_id": 12,
      "region_id": 5,
      "name_ar": "الهفوف",
      "name_en": "Al Hafuf",
      "center": [
        25.36655003,
        49.60435986
      ]
    },
    {
      "city_id": 13,
      "region_id": 5,
      "name_ar": "الدمام",
      "name_en": "Dammam",
      "center": [
        26.44199002,
        50.10919981
      ]
    },
    {
      "city_id": 14,
      "region_id": 3,
      "name_ar": "المدينة المنورة",
      "name_en": "Madinah",
      "center": [
        24.47057996,
        39.60781006
      ]
    },
    {
      "city_id": 15,
      "region_id": 6,
      "name_ar": "ابها",
      "name_en": "Abha",
      "center": [
        18.21667,
        42.50000002
      ]
    },
    {
      "city_id": 16,
      "region_id": 7,
      "name_ar": "حالة عمار",
      "name_en": "Halat Ammar",
      "center": [
        29.16381002,
        36.07205999
      ]
    },
    {
      "city_id": 17,
      "region_id": 10,
      "name_ar": "جازان",
      "name_en": "Jazan",
      "center": [
        16.89671995,
        42.55360001
      ]
    },
    {
      "city_id": 18,
      "region_id": 2,
      "name_ar": "جدة",
      "name_en": "Jeddah",
      "center": [
        21.48817996,
        39.18094995
      ]
    },
    {
      "city_id": 19,
      "region_id": 7,
      "name_ar": "الشايب",
      "name_en": "Ash Shayib",
      "center": [
        29.06630999,
        36.68010006
      ]
    },
    {
      "city_id": 20,
      "region_id": 7,
      "name_ar": "الفوهة",
      "name_en": "Al Fawhah",
      "center": [
        28.27168004,
        36.21439994
      ]
    },
    {
      "city_id": 21,
      "region_id": 7,
      "name_ar": "اللوز",
      "name_en": "Al Lawz",
      "center": [
        28.43635995,
        35.52820998
      ]
    },
    {
      "city_id": 22,
      "region_id": 7,
      "name_ar": "عين الأخضر",
      "name_en": "'Ayn Al Akhdar",
      "center": [
        27.55677998,
        36.75101002
      ]
    },
    {
      "city_id": 23,
      "region_id": 7,
      "name_ar": "ذات الحاج",
      "name_en": "Dhat Al Hajj",
      "center": [
        29.05491001,
        36.16480001
      ]
    },
    {
      "city_id": 24,
      "region_id": 1,
      "name_ar": "المجمعة",
      "name_en": "Al Majma'ah",
      "center": [
        25.90742996,
        45.33901994
      ]
    },
    {
      "city_id": 25,
      "region_id": 7,
      "name_ar": "قيال",
      "name_en": "Qiyal",
      "center": [
        28.15173996,
        35.03499001
      ]
    },
    {
      "city_id": 26,
      "region_id": 7,
      "name_ar": "الاخضر",
      "name_en": "Al Akhdar",
      "center": [
        28.10812997,
        37.08190995
      ]
    },
    {
      "city_id": 27,
      "region_id": 7,
      "name_ar": "البديعة",
      "name_en": "Al Badi'ah",
      "center": [
        27.80688002,
        36.52946006
      ]
    },
    {
      "city_id": 28,
      "region_id": 7,
      "name_ar": "مغيرة",
      "name_en": "Mughayrah",
      "center": [
        29.29676999,
        37.66740996
      ]
    },
    {
      "city_id": 29,
      "region_id": 7,
      "name_ar": "الهوجاء",
      "name_en": "Al Hawja'",
      "center": [
        28.98485006,
        38.56971998
      ]
    },
    {
      "city_id": 30,
      "region_id": 7,
      "name_ar": "البديع",
      "name_en": "Al Badi'",
      "center": [
        29.11108995,
        36.00439997
      ]
    },
    {
      "city_id": 31,
      "region_id": 5,
      "name_ar": "الخبر",
      "name_en": "Al Khobar",
      "center": [
        26.31090997,
        50.21074975
      ]
    },
    {
      "city_id": 32,
      "region_id": 7,
      "name_ar": "ابار قنا",
      "name_en": "Abar Qana",
      "center": [
        27.94455999,
        36.35010002
      ]
    },
    {
      "city_id": 33,
      "region_id": 7,
      "name_ar": "الجبعاوية",
      "name_en": "Al Jab'awiyah",
      "center": [
        28.28974995,
        38.65139005
      ]
    },
    {
      "city_id": 34,
      "region_id": 7,
      "name_ar": "الحميضة",
      "name_en": "Al Humaydah",
      "center": [
        29.23575,
        34.93879002
      ]
    },
    {
      "city_id": 35,
      "region_id": 7,
      "name_ar": "البيانة",
      "name_en": "Al Bayyanah",
      "center": [
        29.13392997,
        35.38569995
      ]
    },
    {
      "city_id": 36,
      "region_id": 7,
      "name_ar": "حقل",
      "name_en": "Haql",
      "center": [
        29.30102998,
        34.94863003
      ]
    },
    {
      "city_id": 37,
      "region_id": 7,
      "name_ar": "الدرة",
      "name_en": "Ad Durrah",
      "center": [
        29.35414,
        34.96193
      ]
    },
    {
      "city_id": 38,
      "region_id": 7,
      "name_ar": "الزيتة",
      "name_en": "Az Zaytah",
      "center": [
        28.87198799,
        35.51700285
      ]
    },
    {
      "city_id": 39,
      "region_id": 7,
      "name_ar": "علقان",
      "name_en": "'Alaqan",
      "center": [
        29.05222997,
        35.42471004
      ]
    },
    {
      "city_id": 40,
      "region_id": 7,
      "name_ar": "الوادي الجديد",
      "name_en": "Al Wadi Al Jadid",
      "center": [
        29.15739001,
        35.03154999
      ]
    },
    {
      "city_id": 41,
      "region_id": 7,
      "name_ar": "مليح",
      "name_en": "Mulayh",
      "center": [
        29.16804999,
        35.40096995
      ]
    },
    {
      "city_id": 42,
      "region_id": 7,
      "name_ar": "ابو الحنشان",
      "name_en": "Abu Al Hinshan",
      "center": [
        29.20217996,
        35.19598002
      ]
    },
    {
      "city_id": 43,
      "region_id": 7,
      "name_ar": "مقنا",
      "name_en": "Maqna",
      "center": [
        28.40485995,
        34.73639996
      ]
    },
    {
      "city_id": 44,
      "region_id": 5,
      "name_ar": "ابو قعر",
      "name_en": "Abu Qa'ar",
      "center": [
        28.37527004,
        45.96298004
      ]
    },
    {
      "city_id": 45,
      "region_id": 5,
      "name_ar": "مركز العوجاء",
      "name_en": "Markaz Al 'Awja",
      "center": [
        29.02743004,
        46.43006007
      ]
    },
    {
      "city_id": 46,
      "region_id": 5,
      "name_ar": "مركز العليمة",
      "name_en": "Markaz Al 'Ulayyimah",
      "center": [
        29.07298004,
        46.24333999
      ]
    },
    {
      "city_id": 47,
      "region_id": 5,
      "name_ar": "حفر الباطن",
      "name_en": "Hafar Al Batin",
      "center": [
        28.43750001,
        45.98046997
      ]
    },
    {
      "city_id": 48,
      "region_id": 5,
      "name_ar": "القلت",
      "name_en": "Al Qalt",
      "center": [
        28.55181997,
        45.54736003
      ]
    },
    {
      "city_id": 49,
      "region_id": 5,
      "name_ar": "النظيم",
      "name_en": "An Nadhim",
      "center": [
        28.67294999,
        45.23121003
      ]
    },
    {
      "city_id": 50,
      "region_id": 5,
      "name_ar": "ابن طوالة",
      "name_en": "Ibn Tuwalah",
      "center": [
        28.61736004,
        45.35671001
      ]
    },
    {
      "city_id": 51,
      "region_id": 5,
      "name_ar": "الصداوي",
      "name_en": "As Sidawi",
      "center": [
        28.10972,
        46.7247
      ]
    },
    {
      "city_id": 52,
      "region_id": 5,
      "name_ar": "ام قليب",
      "name_en": "Umm Qulaib",
      "center": [
        27.83416994,
        45.97311998
      ]
    },
    {
      "city_id": 53,
      "region_id": 5,
      "name_ar": "عريفج",
      "name_en": "Urayfij",
      "center": [
        27.81619997,
        45.55191005
      ]
    },
    {
      "city_id": 54,
      "region_id": 5,
      "name_ar": "ابن شرار",
      "name_en": "Ibn Sharar",
      "center": [
        27.83570005,
        46.42083002
      ]
    },
    {
      "city_id": 55,
      "region_id": 5,
      "name_ar": "القيصومة",
      "name_en": "Al Qaysumah",
      "center": [
        28.32198001,
        46.12942998
      ]
    },
    {
      "city_id": 56,
      "region_id": 5,
      "name_ar": "الرقعي الجديدة",
      "name_en": "Ar Ruq'i Al Jadidah",
      "center": [
        28.98338333,
        46.57391667
      ]
    },
    {
      "city_id": 57,
      "region_id": 5,
      "name_ar": "ذبحة",
      "name_en": "Dhabhah",
      "center": [
        27.94057003,
        45.38029995
      ]
    },
    {
      "city_id": 58,
      "region_id": 5,
      "name_ar": "الصفيري",
      "name_en": "As Sufairy",
      "center": [
        28.53147002,
        45.80909006
      ]
    },
    {
      "city_id": 59,
      "region_id": 5,
      "name_ar": "الوايلية",
      "name_en": "Al Wayliyah",
      "center": [
        28.44200002,
        45.79369
      ]
    },
    {
      "city_id": 60,
      "region_id": 5,
      "name_ar": "الفيوان",
      "name_en": "Al Fiwan",
      "center": [
        28.23975,
        45.80167004
      ]
    },
    {
      "city_id": 61,
      "region_id": 5,
      "name_ar": "الحماطيات",
      "name_en": "Al Hamatiyat",
      "center": [
        28.89257998,
        47.53099993
      ]
    },
    {
      "city_id": 62,
      "region_id": 6,
      "name_ar": "خميس مشيط",
      "name_en": "Khamis Mushayt",
      "center": [
        18.30613002,
        42.72976998
      ]
    },
    {
      "city_id": 63,
      "region_id": 5,
      "name_ar": "الجبو",
      "name_en": "Al Jabu",
      "center": [
        28.96981996,
        47.38223997
      ]
    },
    {
      "city_id": 64,
      "region_id": 5,
      "name_ar": "المسناة",
      "name_en": "Al Masnah",
      "center": [
        28.97782005,
        47.14768002
      ]
    },
    {
      "city_id": 65,
      "region_id": 6,
      "name_ar": "احد رفيده",
      "name_en": "Ahad Rifaydah",
      "center": [
        18.17358001,
        42.83663
      ]
    },
    {
      "city_id": 66,
      "region_id": 5,
      "name_ar": "ام عشر الشرقية",
      "name_en": "Umm Ishar Ash Sharqiyyah",
      "center": [
        27.72695001,
        45.06599
      ]
    },
    {
      "city_id": 67,
      "region_id": 5,
      "name_ar": "القطيف",
      "name_en": "Al Qatif",
      "center": [
        26.56387002,
        50.00120987
      ]
    },
    {
      "city_id": 68,
      "region_id": 7,
      "name_ar": "بوهان",
      "name_en": "Buhan",
      "center": [
        27.73134003,
        38.67754006
      ]
    },
    {
      "city_id": 69,
      "region_id": 7,
      "name_ar": "السنانيات",
      "name_en": "As Sananiyat",
      "center": [
        27.34904001,
        38.68147003
      ]
    },
    {
      "city_id": 70,
      "region_id": 7,
      "name_ar": "حزايا",
      "name_en": "Hazaya",
      "center": [
        27.19260998,
        39.53592997
      ]
    },
    {
      "city_id": 71,
      "region_id": 7,
      "name_ar": "أكباد",
      "name_en": "Akbad",
      "center": [
        27.23691995,
        39.25667003
      ]
    },
    {
      "city_id": 72,
      "region_id": 7,
      "name_ar": "بئر الحيز",
      "name_en": "Bir Al Hayz",
      "center": [
        27.50948995,
        39.29335
      ]
    },
    {
      "city_id": 73,
      "region_id": 7,
      "name_ar": "جريداء",
      "name_en": "Jurayda",
      "center": [
        27.69618999,
        38.13729996
      ]
    },
    {
      "city_id": 74,
      "region_id": 7,
      "name_ar": "تيماء",
      "name_en": "Tayma'",
      "center": [
        27.63502,
        38.55060002
      ]
    },
    {
      "city_id": 75,
      "region_id": 7,
      "name_ar": "العسافية",
      "name_en": "Al Assafiyah",
      "center": [
        28.27779001,
        38.97937005
      ]
    },
    {
      "city_id": 76,
      "region_id": 3,
      "name_ar": "عردة",
      "name_en": "'Ardah",
      "center": [
        26.98273003,
        38.37073
      ]
    },
    {
      "city_id": 77,
      "region_id": 7,
      "name_ar": "الكتيب",
      "name_en": "Al Kutaib",
      "center": [
        27.52023997,
        38.85158
      ]
    },
    {
      "city_id": 78,
      "region_id": 7,
      "name_ar": "بئر فجر",
      "name_en": "Bi'r Fajr",
      "center": [
        28.82116003,
        37.86915
      ]
    },
    {
      "city_id": 79,
      "region_id": 7,
      "name_ar": "القليبة",
      "name_en": "Al Qalibah",
      "center": [
        28.37872001,
        37.69301007
      ]
    },
    {
      "city_id": 80,
      "region_id": 4,
      "name_ar": "عنيزة",
      "name_en": "Unayzah",
      "center": [
        26.09155002,
        43.98767004
      ]
    },
    {
      "city_id": 81,
      "region_id": 5,
      "name_ar": "الرافعية",
      "name_en": "Ar Raf'iyah",
      "center": [
        28.50715001,
        48.35748998
      ]
    },
    {
      "city_id": 82,
      "region_id": 5,
      "name_ar": "الكبريت",
      "name_en": "Al Kabarit",
      "center": [
        28.11393004,
        47.88718
      ]
    },
    {
      "city_id": 83,
      "region_id": 5,
      "name_ar": "رغوة",
      "name_en": "Raghwah",
      "center": [
        28.49882,
        48.20407998
      ]
    },
    {
      "city_id": 84,
      "region_id": 5,
      "name_ar": "حمى",
      "name_en": "Hima",
      "center": [
        28.49789999,
        47.87939997
      ]
    },
    {
      "city_id": 85,
      "region_id": 5,
      "name_ar": "الزبر",
      "name_en": "Az Zabr",
      "center": [
        28.56035005,
        47.68656004
      ]
    },
    {
      "city_id": 86,
      "region_id": 5,
      "name_ar": "السفانية",
      "name_en": "As Saffaniyah",
      "center": [
        27.97736997,
        48.74034992
      ]
    },
    {
      "city_id": 87,
      "region_id": 5,
      "name_ar": "المحوى",
      "name_en": "Al Mahawa",
      "center": [
        27.58394001,
        47.20781996
      ]
    },
    {
      "city_id": 88,
      "region_id": 5,
      "name_ar": "أم غور",
      "name_en": "Umm Ghawr",
      "center": [
        27.07205005,
        47.10267999
      ]
    },
    {
      "city_id": 89,
      "region_id": 5,
      "name_ar": "قرية العليا",
      "name_en": "Qaryat Al 'Ulya",
      "center": [
        27.56297,
        47.70039992
      ]
    },
    {
      "city_id": 90,
      "region_id": 5,
      "name_ar": "الرفيعة",
      "name_en": "Ar Rafi'ah",
      "center": [
        27.02027003,
        47.05991003
      ]
    },
    {
      "city_id": 91,
      "region_id": 5,
      "name_ar": "جرارة",
      "name_en": "Jarrarah",
      "center": [
        27.02106996,
        47.06168006
      ]
    },
    {
      "city_id": 92,
      "region_id": 5,
      "name_ar": "قرية",
      "name_en": "Qurayyah",
      "center": [
        27.49244004,
        47.86960994
      ]
    },
    {
      "city_id": 93,
      "region_id": 5,
      "name_ar": "البويبيات",
      "name_en": "Al Buwaybiyat",
      "center": [
        26.87647003,
        47.11905004
      ]
    },
    {
      "city_id": 94,
      "region_id": 5,
      "name_ar": "السعيرة",
      "name_en": "As Su'ayyirah",
      "center": [
        27.82641004,
        47.51989003
      ]
    },
    {
      "city_id": 95,
      "region_id": 5,
      "name_ar": "مناخ",
      "name_en": "Manakh",
      "center": [
        27.60841995,
        46.31459006
      ]
    },
    {
      "city_id": 96,
      "region_id": 5,
      "name_ar": "الحيرا",
      "name_en": "Al Hayra",
      "center": [
        27.70068001,
        46.63575006
      ]
    },
    {
      "city_id": 97,
      "region_id": 5,
      "name_ar": "ام الشفلح",
      "name_en": "Umm Ash Shifallah",
      "center": [
        27.60863004,
        47.01677996
      ]
    },
    {
      "city_id": 98,
      "region_id": 5,
      "name_ar": "اللهابة",
      "name_en": "Al Lahabah",
      "center": [
        27.25212004,
        46.97898004
      ]
    },
    {
      "city_id": 99,
      "region_id": 5,
      "name_ar": "الفريدة",
      "name_en": "Al Farridah",
      "center": [
        27.18380005,
        46.98244006
      ]
    },
    {
      "city_id": 100,
      "region_id": 5,
      "name_ar": "الشامية",
      "name_en": "Ash Shamiyah",
      "center": [
        27.12077998,
        47.00155001
      ]
    },
    {
      "city_id": 101,
      "region_id": 1,
      "name_ar": "العيطلية",
      "name_en": "Al 'Aytaliyah",
      "center": [
        26.57024005,
        47.08091993
      ]
    },
    {
      "city_id": 102,
      "region_id": 5,
      "name_ar": "سحمة",
      "name_en": "Sihmah",
      "center": [
        26.39243001,
        47.83330998
      ]
    },
    {
      "city_id": 103,
      "region_id": 5,
      "name_ar": "الشملول / ام عقلا",
      "name_en": "Ash Shamlul (Umm Aqla)",
      "center": [
        26.51930995,
        47.33969994
      ]
    },
    {
      "city_id": 104,
      "region_id": 5,
      "name_ar": "ام الهوشات",
      "name_en": "Umm Al Hawshat",
      "center": [
        26.99945,
        47.23080999
      ]
    },
    {
      "city_id": 105,
      "region_id": 5,
      "name_ar": "الشيط",
      "name_en": "Ash Shayyit",
      "center": [
        27.55494997,
        47.27886006
      ]
    },
    {
      "city_id": 106,
      "region_id": 5,
      "name_ar": "العاذرية",
      "name_en": "Al 'Adhiriyah",
      "center": [
        27.05265997,
        47.04075004
      ]
    },
    {
      "city_id": 107,
      "region_id": 5,
      "name_ar": "الشيحية",
      "name_en": "Ash Shihiyah",
      "center": [
        27.07845994,
        47.01776001
      ]
    },
    {
      "city_id": 108,
      "region_id": 1,
      "name_ar": "حزوة / العمانية",
      "name_en": "Hizwah (Al Umaniyah)",
      "center": [
        26.37749004,
        47.32533993
      ]
    },
    {
      "city_id": 109,
      "region_id": 5,
      "name_ar": "القرعاء",
      "name_en": "Al Qar'a",
      "center": [
        27.46099994,
        46.86235001
      ]
    },
    {
      "city_id": 110,
      "region_id": 5,
      "name_ar": "اللصافة",
      "name_en": "Al Lisafah",
      "center": [
        27.62415995,
        46.87004998
      ]
    },
    {
      "city_id": 111,
      "region_id": 5,
      "name_ar": "النقيرة",
      "name_en": "An Nuqayrah",
      "center": [
        27.86851651,
        48.26292494
      ]
    },
    {
      "city_id": 112,
      "region_id": 5,
      "name_ar": "هجرة أولاد حثلين",
      "name_en": "Hijrat Awlad Hithlin",
      "center": [
        27.66292999,
        48.30616993
      ]
    },
    {
      "city_id": 113,
      "region_id": 5,
      "name_ar": "الجبيل",
      "name_en": "Al Jubail",
      "center": [
        26.99921004,
        49.67046985
      ]
    }
  ]